var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurchaseQuatation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 5.75H13",
    stroke: "#64748B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8.75H10",
    stroke: "#64748B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 16.625V16.25C10.75 14.1287 10.75 13.0681 11.409 12.409C12.0681 11.75 13.1287 11.75 15.25 11.75H15.625M16 10.5073V8C16 5.17157 16 3.75736 15.1213 2.87868C14.2427 2 12.8284 2 10 2C7.17158 2 5.75736 2 4.87868 2.87868C4 3.75736 4 5.17157 4 8V11.4081C4 13.8419 4 15.0588 4.66455 15.883C4.79881 16.0495 4.95048 16.2012 5.117 16.3354C5.94123 17 7.15811 17 9.59185 17C10.1211 17 10.3856 17 10.6279 16.9145C10.6783 16.8967 10.7277 16.8763 10.7759 16.8532C11.0077 16.7423 11.1947 16.5553 11.5689 16.1811L15.1213 12.6287C15.5549 12.1951 15.7716 11.9784 15.8858 11.7027C16 11.4271 16 11.1204 16 10.5073Z",
    stroke: "#64748B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseQuatation);
export default __webpack_public_path__ + "static/media/purchaseQuatation.be18cb51aae3269269fe768b8ace70ee.svg";
export { ForwardRef as ReactComponent };